module.exports = __webpack_public_path__ + "img/dsBotaoPorta.7e67e47b.svg";